import { createStore } from "redux";

// Secure cookie utilities
const encodeCookie = (data) => btoa(JSON.stringify(data));
const decodeCookie = (encoded) => JSON.parse(atob(encoded));

const defaultState = {
  isLoggedIn: false,
  token: "",
  userId: "",
  cartCount: 0,
};

const storeReducer = (state = defaultState, action) => {
  if (action.type === "logIn") {
    const data = action.data;

    const obj = {
      isLoggedIn: true,
      token: data.token,
      userId: data.userId,
    };
    const encodedData = encodeCookie(obj);
    document.cookie = `userData=${encodedData}; path=/; max-age=2592000; Secure; SameSite=Strict`;

    return {
      ...state,
      ...obj,
    };
  }

  if (action.type === "logout") {
    const obj = {
      isLoggedIn: false,
      token: "",
      userId: "",
    };

    document.cookie =
      "userData=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; Secure; SameSite=Strict";
    return { ...obj };
  }

  // if (action.type === "reload") {
  //   return {
  //     ...action.data,
  //   };
  // }

  return state;
};
const store = createStore(storeReducer);

export default store;
